import React, { useState, useEffect } from "react";

const VendorQuotations = () => {
    const [quotations, setQuotations] = useState([]);
    const [filter, setFilter] = useState("all");
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [showPopup, setShowPopup] = useState(false);


    useEffect(() => {

        const mockQuotations = [
            {
                id: 1,
                enquiryId: 63,
                vendorId: 101,
                vendorName: "Fresh Foods Catering",
                status: "accepted",
                quotationDate: "20/02/2026",
                validUntil: "25/02/2026",
                vegPerPlatePrice: 350,
                nonVegPerPlatePrice: 450,
                mixedPerPlatePrice: 400,
                quotationDetails: "Includes all menu items with premium ingredients. Special discount for bulk order.",
                addOnPrices: [
                    {
                        addOnId: 1,
                        addOnType: "EXTRA_STARTER",
                        quantity: 2,
                        price: 500,
                        totalAmount: 1000
                    },
                    {
                        addOnId: 2,
                        addOnType: "DESSERT_COUNTER",
                        quantity: 1,
                        price: 800,
                        totalAmount: 800
                    }
                ]
            },
            {
                id: 2,
                enquiryId: 63,
                vendorId: 102,
                vendorName: "Spice Garden",
                status: "pending",
                quotationDate: "21/02/2026",
                validUntil: "26/02/2026",
                vegPerPlatePrice: 320,
                nonVegPerPlatePrice: 420,
                mixedPerPlatePrice: 370,
                quotationDetails: "Competitive pricing with authentic spices. Includes complimentary welcome drink.",
                addOnPrices: [
                    {
                        addOnId: 3,
                        addOnType: "LIVE_COUNTER",
                        quantity: 1,
                        price: 1200,
                        totalAmount: 1200
                    }
                ]
            },
            {
                id: 3,
                enquiryId: 63,
                vendorId: 104,
                vendorName: "Urban Tadka Caterers",
                status: "rejected",
                quotationDate: "19/02/2026",
                validUntil: "24/02/2026",
                vegPerPlatePrice: 380,
                nonVegPerPlatePrice: 480,
                mixedPerPlatePrice: 430,
                quotationDetails: "Premium package with additional items. Includes decorative food displays.",
                addOnPrices: [
                    {
                        addOnId: 4,
                        addOnType: "DECORATIVE_SETUP",
                        quantity: 1,
                        price: 1500,
                        totalAmount: 1500
                    },
                    {
                        addOnId: 5,
                        addOnType: "SPECIAL_DESSERT",
                        quantity: 3,
                        price: 200,
                        totalAmount: 600
                    }
                ]
            },
            {
                id: 4,
                enquiryId: 64,
                vendorId: 101,
                vendorName: "Fresh Foods Catering",
                status: "accepted",
                quotationDate: "22/02/2026",
                validUntil: "27/02/2026",
                vegPerPlatePrice: 340,
                nonVegPerPlatePrice: 440,
                mixedPerPlatePrice: 390,
                quotationDetails: "Wedding special menu with dessert counter. Includes staff service.",
                addOnPrices: [
                    {
                        addOnId: 6,
                        addOnType: "STAFF_SERVICE",
                        quantity: 4,
                        price: 300,
                        totalAmount: 1200
                    },
                    {
                        addOnId: 7,
                        addOnType: "BEVERAGE_COUNTER",
                        quantity: 1,
                        price: 1000,
                        totalAmount: 1000
                    }
                ]
            },
            {
                id: 5,
                enquiryId: 64,
                vendorId: 105,
                vendorName: "Grand Feast Events",
                status: "pending",
                quotationDate: "23/02/2026",
                validUntil: "28/02/2026",
                vegPerPlatePrice: 330,
                nonVegPerPlatePrice: 430,
                mixedPerPlatePrice: 380,
                quotationDetails: "Competitive pricing for wedding event. Includes complimentary cake cutting.",
                addOnPrices: []
            },
            {
                id: 6,
                enquiryId: 65,
                vendorId: 103,
                vendorName: "Royal Dine Services",
                status: "pending",
                quotationDate: "18/02/2026",
                validUntil: "23/02/2026",
                vegPerPlatePrice: 300,
                nonVegPerPlatePrice: 400,
                mixedPerPlatePrice: 350,
                quotationDetails: "Basic package with standard items. Economical option for small events.",
                addOnPrices: [
                    {
                        addOnId: 8,
                        addOnType: "EXTRA_DESSERT",
                        quantity: 2,
                        price: 150,
                        totalAmount: 300
                    }
                ]
            }
        ];

        setQuotations(mockQuotations);
    }, []);

    // Format currency
    const formatCurrency = (amount) => {
        return `₹${parseInt(amount).toLocaleString('en-IN')}`;
    };

    // Format date
    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        return dateString;
    };

    // Calculate total quotation amount
    const calculateTotalQuotation = (quotation) => {
        // Calculate plates total based on actual order counts (this would come from order data)
        // For demo purposes, assuming 100 plates total
        const vegPlates = 80;
        const nonVegPlates = 10;
        const mixedPlates = 10;

        const platesTotal = (vegPlates * quotation.vegPerPlatePrice) +
            (nonVegPlates * quotation.nonVegPerPlatePrice) +
            (mixedPlates * quotation.mixedPerPlatePrice);

        const addOnsTotal = quotation.addOnPrices.reduce((sum, addon) => sum + addon.totalAmount, 0);

        return platesTotal + addOnsTotal;
    };

    // Get filtered quotations based on status
    const getFilteredQuotations = () => {
        switch (filter) {
            case "pending":
                return quotations.filter(q => q.status === "pending");
            case "accepted":
                return quotations.filter(q => q.status === "accepted");
            case "rejected":
                return quotations.filter(q => q.status === "rejected");
            default:
                return quotations;
        }
    };

    // Get statistics
    const getStatistics = () => {
        const total = quotations.length;
        const pending = quotations.filter(q => q.status === "pending").length;
        const accepted = quotations.filter(q => q.status === "accepted").length;
        const rejected = quotations.filter(q => q.status === "rejected").length;

        return { total, pending, accepted, rejected };
    };

    // Handle filter change
    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    // Get status badge style
    const getStatusBadge = (status) => {
        switch (status) {
            case "accepted":
                return {
                    backgroundColor: "#d4edda",
                    color: "#155724",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    display: "inline-block"
                };
            case "pending":
                return {
                    backgroundColor: "#fff3cd",
                    color: "#856404",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    display: "inline-block"
                };
            case "rejected":
                return {
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "11px",
                    fontWeight: "bold",
                    display: "inline-block"
                };
            default:
                return {};
        }
    };

    // Styles
    const styles = {
        container: {
            padding: "20px",
            backgroundColor: "#f5f5f5",
            minHeight: "100vh",
            width: "100%",
            boxSizing: "border-box"
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            flexDirection: window.innerWidth < 768 ? "column" : "row",
            gap: "15px"
        },
        title: {
            fontSize: window.innerWidth < 768 ? "20px" : "24px",
            fontWeight: "bold",
            color: "#333",
            margin: 0,
            textAlign: window.innerWidth < 768 ? "center" : "left"
        },
        filterContainer: {
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center"
        },
        filterLabel: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#666"
        },
        filterSelect: {
            padding: "10px 16px",
            border: "1px solid #ddd",
            borderRadius: "5px",
            fontSize: "14px",
            backgroundColor: "white",
            cursor: "pointer",
            minWidth: "180px",
            outline: "none",
            transition: "border-color 0.3s ease",
            ":focus": {
                borderColor: "rgb(230 109 51)"
            }
        },
        statsContainer: {
            display: "flex",
            gap: window.innerWidth < 768 ? "10px" : "20px",
            flexWrap: "wrap",
            marginBottom: "20px",
            padding: "15px",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        },
        statItem: {
            display: "flex",
            alignItems: "center",
            gap: "5px"
        },
        statBadge: {
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "11px",
            fontWeight: "bold",
            whiteSpace: "nowrap"
        },
        tableContainer: {
            width: "100%",
            overflowX: "auto",
            borderRadius: "8px",
            border: "1px solid #ddd",
            backgroundColor: "white"
        },
        table: {
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1000px"
        },
        tableHeader: {
            backgroundColor: "rgb(230 109 51)",
            color: "white",
            padding: "12px",
            textAlign: "left",
            fontSize: window.innerWidth < 768 ? "12px" : "14px",
            whiteSpace: "nowrap"
        },
        tableCell: {
            padding: window.innerWidth < 768 ? "8px" : "12px",
            borderBottom: "1px solid #ddd",
            fontSize: window.innerWidth < 768 ? "12px" : "14px"
        },
        quotationCell: {
            padding: window.innerWidth < 768 ? "8px" : "12px",
            borderBottom: "1px solid #ddd",
            fontSize: window.innerWidth < 768 ? "12px" : "14px",
            fontWeight: "bold",
            color: "rgb(230 109 51)"
        },
        viewButton: {
            backgroundColor: "rgb(230 109 51)",
            color: "white",
            border: "none",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "12px",
            fontWeight: "bold"
        },
        // Popup styles
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10001
        },
        popup: {
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "25px",
            maxWidth: "800px",
            width: "90%",
            maxHeight: "90vh",
            overflowY: "auto",
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            position: "relative"
        },
        popupHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "10px",
            borderBottom: "2px solid rgb(230 109 51)"
        },
        popupTitle: {
            fontSize: "20px",
            fontWeight: "bold",
            color: "#333",
            margin: 0
        },
        closeButton: {
            background: "none",
            border: "none",
            fontSize: "24px",
            cursor: "pointer",
            color: "#666",
            padding: "0 10px"
        },
        priceGrid: {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "15px",
            marginBottom: "20px"
        },
        priceCard: {
            padding: "15px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
            border: "1px solid #dee2e6"
        },
        priceLabel: {
            fontSize: "13px",
            color: "#666",
            marginBottom: "5px"
        },
        priceValue: {
            fontSize: "18px",
            fontWeight: "bold",
            color: "rgb(230 109 51)"
        },
        sectionTitle: {
            color: "rgb(230 109 51)",
            marginBottom: "10px",
            fontSize: "16px",
            fontWeight: "bold"
        },
        detailsText: {
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderRadius: "6px",
            marginBottom: "20px"
        },
        addOnsTable: {
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "10px"
        },
        addOnsHeader: {
            backgroundColor: "#e9ecef",
            padding: "10px",
            textAlign: "left",
            fontSize: "13px",
            fontWeight: "bold"
        },
        addOnsCell: {
            padding: "8px",
            borderBottom: "1px solid #dee2e6",
            fontSize: "13px"
        }
    };

    const stats = getStatistics();
    const filteredQuotations = getFilteredQuotations();

    return (
        <div style={styles.container}>
            {/* Header with filters */}
            <div style={styles.header}>

                <div style={styles.filterContainer}>
                    <label htmlFor="filter-select" style={styles.filterLabel}>
                        Filter by:
                    </label>
                    <select
                        id="filter-select"
                        value={filter}
                        onChange={handleFilterChange}
                        style={styles.filterSelect}
                    >
                        <option value="all">All Quotations ({stats.total})</option>
                        <option value="pending">Pending ({stats.pending})</option>
                        <option value="accepted">Accepted ({stats.accepted})</option>
                        <option value="rejected">Rejected ({stats.rejected})</option>
                    </select>
                </div>
            </div>

            {/* Statistics Cards */}
            <div style={styles.statsContainer}>
                <div style={styles.statItem}>
                    <span style={{ color: "#666", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>Total Quotations:</span>
                    <span style={{ fontWeight: "bold", fontSize: window.innerWidth < 768 ? "12px" : "14px" }}>{stats.total}</span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#fff3cd", color: "#856404" }}>
                        Pending: {stats.pending}
                    </span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#d4edda", color: "#155724" }}>
                        Accepted: {stats.accepted}
                    </span>
                </div>
                <div style={styles.statItem}>
                    <span style={{ ...styles.statBadge, backgroundColor: "#f8d7da", color: "#721c24" }}>
                        Rejected: {stats.rejected}
                    </span>
                </div>
            </div>

            {/* Main Table with Enquiry ID, Vendor ID, and Quotation */}
            <div style={styles.tableContainer}>
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.tableHeader}>Enquiry ID</th>
                            <th style={styles.tableHeader}>Vendor ID</th>
                            <th style={styles.tableHeader}>Vendor Name</th>
                            <th style={styles.tableHeader}>Veg/Plate</th>
                            <th style={styles.tableHeader}>Non-Veg/Plate</th>
                            {/* <th style={styles.tableHeader}>Mixed/Plate</th> */}
                            <th style={styles.tableHeader}>Total Quotation</th>
                            <th style={styles.tableHeader}>Status</th>
                            <th style={styles.tableHeader}>Quotation Date</th>
                            <th style={styles.tableHeader}>Valid Until</th>
                            <th style={styles.tableHeader}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredQuotations.map((quotation) => (
                            <tr key={quotation.id}>
                                <td style={styles.tableCell}>
                                    <strong>#{quotation.enquiryId}</strong>
                                </td>
                                <td style={styles.tableCell}>
                                    <strong>#{quotation.vendorId}</strong>
                                </td>
                                <td style={styles.tableCell}>
                                    {quotation.vendorName}
                                </td>
                                <td style={styles.tableCell}>
                                    {formatCurrency(quotation.vegPerPlatePrice)}
                                </td>
                                <td style={styles.tableCell}>
                                    {formatCurrency(quotation.nonVegPerPlatePrice)}
                                </td>
                                {/* <td style={styles.tableCell}>
                                    {formatCurrency(quotation.mixedPerPlatePrice)}
                                </td> */}
                                <td style={styles.quotationCell}>
                                    {formatCurrency(calculateTotalQuotation(quotation))}
                                </td>
                                <td style={styles.tableCell}>
                                    <span style={getStatusBadge(quotation.status)}>
                                        {quotation.status.charAt(0).toUpperCase() + quotation.status.slice(1)}
                                    </span>
                                </td>
                                <td style={styles.tableCell}>
                                    {formatDate(quotation.quotationDate)}
                                </td>
                                <td style={styles.tableCell}>
                                    {formatDate(quotation.validUntil)}
                                </td>
                                <td style={styles.tableCell}>
                                    <button
                                        style={styles.viewButton}
                                        onClick={() => {
                                            setSelectedQuotation(quotation);
                                            setShowPopup(true);
                                        }}
                                    >
                                        View Details
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {filteredQuotations.length === 0 && (
                            <tr>
                                <td colSpan="11" style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                                    No quotations match the selected filter
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Popup for Quotation Details */}
            {showPopup && selectedQuotation && (
                <div style={styles.overlay} onClick={() => setShowPopup(false)}>
                    <div style={styles.popup} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.popupHeader}>
                            <h3 style={styles.popupTitle}>
                                Quotation Details - Enquiry #{selectedQuotation.enquiryId}
                            </h3>
                            <button
                                style={styles.closeButton}
                                onClick={() => setShowPopup(false)}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{ marginBottom: "15px" }}>
                            <strong>Vendor:</strong> #{selectedQuotation.vendorId} - {selectedQuotation.vendorName}
                        </div>

                        {/* Per Plate Prices */}
                        <div style={styles.priceGrid}>
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}>Veg Per Plate</div>
                                <div style={styles.priceValue}>{formatCurrency(selectedQuotation.vegPerPlatePrice)}</div>
                            </div>
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}>Non-Veg Per Plate</div>
                                <div style={styles.priceValue}>{formatCurrency(selectedQuotation.nonVegPerPlatePrice)}</div>
                            </div>
                            {/* <div style={styles.priceCard}>
                                <div style={styles.priceLabel}>Mixed Per Plate</div>
                                <div style={styles.priceValue}>{formatCurrency(selectedQuotation.mixedPerPlatePrice)}</div>
                            </div> */}
                            <div style={styles.priceCard}>
                                <div style={styles.priceLabel}>Total Amount</div>
                                <div style={styles.priceValue}>{formatCurrency(calculateTotalQuotation(selectedQuotation))}</div>
                            </div>
                        </div>

                        {/* Quotation Details */}
                        <div style={{ marginBottom: "20px" }}>
                            <h4 style={styles.sectionTitle}>Quotation Details</h4>
                            <div style={styles.detailsText}>
                                {selectedQuotation.quotationDetails}
                            </div>
                        </div>

                        {/* Add-On Prices */}
                        {selectedQuotation.addOnPrices.length > 0 && (
                            <div>
                                <h4 style={styles.sectionTitle}>Add-Ons</h4>
                                <table style={styles.addOnsTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.addOnsHeader}>Add-On ID</th>
                                            <th style={styles.addOnsHeader}>Add-On Type</th>
                                            <th style={styles.addOnsHeader}>Qty</th>
                                            <th style={styles.addOnsHeader}>Unit Price</th>
                                            <th style={styles.addOnsHeader}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedQuotation.addOnPrices.map((addon, index) => (
                                            <tr key={index}>
                                                <td style={styles.addOnsCell}>#{addon.addOnId}</td>
                                                <td style={styles.addOnsCell}>
                                                    {addon.addOnType.split('_').map(word =>
                                                        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                                    ).join(' ')}
                                                </td>
                                                <td style={styles.addOnsCell}>{addon.quantity}</td>
                                                <td style={styles.addOnsCell}>{formatCurrency(addon.price)}</td>
                                                <td style={styles.addOnsCell}>{formatCurrency(addon.totalAmount)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Close button at bottom */}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                            <button
                                style={{
                                    backgroundColor: "rgb(230 109 51)",
                                    color: "white",
                                    border: "none",
                                    padding: "10px 30px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    fontWeight: "bold"
                                }}
                                onClick={() => setShowPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VendorQuotations;